import React from "react";
import styled from "styled-components";

// assets
import DefaultThumbnail from "assets/image/default_thumbnail2.svg";

export const Avatar = ({ src, size, minSize = true }) => {
  return (
    <StyledAvatar
      src={src ? src : DefaultThumbnail}
      size={size}
      minSize={minSize}
      data-clarity-mask="True"
    />
  );
};

const StyledAvatar = styled.img`
  width: ${(props) => (props.size ? props.size + "px" : "60px")};
  height: ${(props) => (props.size ? props.size + "px" : "60px")};
  border-radius: 50%;
  min-width: ${(props) => (props.minSize ? "48px" : "unset")};
  min-height: ${(props) => (props.minSize ? "48px" : "unset")};
  object-fit: cover;
`;
